import React , {useContext} from 'react';
import {RecipesContext} from '../context/RecipesContext';
import Recipe from '../component/Recipe';
const ListRecipes = () => {

    const {recipes} = useContext(RecipesContext);

    return ( 
        <div className="row mt-5">
            {recipes.map(recipe=>(
                <Recipe
                    key={recipe.idDrink}
                    recipe ={recipe}
                ></Recipe>
            ))}
        </div>
     );
}
 
export default ListRecipes;